/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import BootstrapButton from "@/components/form/BootstrapButton"
import Icon from "@/components/Icon"
import { faPrint } from "@fortawesome/free-solid-svg-icons"
import { css } from "vite-css-in-js"
import { FormTabControls, ShadowContainer, defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import type { IncidentFormSection } from "./IncidentFormSection"
import { useIncidentHandler } from "./IncidentLogHandler"

interface Props {
	section: IncidentFormSection
	setSection(sectionId: string): void
	sections: IncidentFormSection[]
}

const navigationStyles = css`
	width: 15rem;
	padding: 0.5rem 0.5rem;

	display: flex;
	flex-direction: column;

	ul {
		flex-direction: column;
		gap: 0;
		flex: 1 1 0;
		overflow: auto;

		&:after {
			display: none;
		}
	}
	li {
		white-space: nowrap;
		font-size: 1.05rem;
		padding: 0.25rem 0.5rem;
	}
`

const QuickNavigation: ReactiveComponent<Props> = (props) => {
	const handler = useIncidentHandler()

	return () => (
		<ShadowContainer class={navigationStyles}>
			<h5>Quick Navigation</h5>
			<hr class="mt-0 mb-2" />
			<FormTabControls
				selectedTabId={props.section.id}
				setSelectedTab={props.setSection}
				tabs={props.sections.map((tab) => ({
					...tab,
					renderTab: (tabProps) => (
						<li
							key={tab.id}
							data-active={String(tabProps.active)}
							onClick={tabProps.onClick}
							style={{ backgroundColor: tab.color }}
						>
							<div>
								<span class="inline-flex items-center spacing-2">
									<Icon icon={tab.icon} />
									<span>{tab.name}</span>
								</span>
							</div>
						</li>
					),
				}))}
			/>

			{!handler.isNewIncident && (
				<>
					<hr class="mb-2" />
					<BootstrapButton
						style={{ fontSize: "0.9rem" }}
						color="success"
						onClick={() => window.open(`/incidents/pdf/${handler.incident.id}`, undefined, "popup noopener noreferrer")}
					>
						<Icon icon={faPrint} />
						<span>Print Incident</span>
					</BootstrapButton>
				</>
			)}
		</ShadowContainer>
	)
}

export default defineComponent(QuickNavigation, inferProps<Props>())
